export class Driver {
    public id?: number;
    public first_name?: string;
    public last_name?: string;
    public personal_phone?: string;
    public business_phone?: string;
    public photo?: string;
    public dni?: string;
    public password?: string;
    public user_id?: string;
    public provider_id?: string;

    
    public user_grouper_id?: number;
    public created_at?: Date;
    public updated_at?: Date;
    public deleted_at?: Date;
}